$('button').on('click',function(e) {
    if ($(this).hasClass('grid')) {
        $('.grid--view-items').removeClass('list').addClass('grid');
    }
    else if($(this).hasClass('list')) {
        $('.grid--view-items').removeClass('grid').addClass('list');
    }
});

 
var abbreivateSize = function(size)
{
	var s = size.toLowerCase();
  
    switch(s)
    {
      case 'extra small':
      case 'x small':
      case 'x-small':
        return 'XS';
        
      case 'small':
        return 'S';
        
      case 'medium':
        return 'M';
        
      case 'large':
        return 'L';
        
      case 'extra large':
      case 'x large':
      case 'xlarge':
      case 'x-large':
        return 'XL';
        
      case '2x large':
      case '2xlarge':
      case '2x-large':
        return '2XL';
        
      case '3x large':
      case '3xlarge':
      case '3x-large':
        return '3XL';
        
      case '4x large':
      case '4xlarge':
      case '4x-large':
        return '4XL';
        
      case '5x large':
      case '5xlarge':
      case '5x-large':
        return '5XL';
        
    }
  
  return size;

};

$(document).ready(function()
{
	if (window.hasOwnProperty('_product') && (typeof window._product == 'object'))
    {

        var v = window._product.variants;
      	var colorData = window._colors.colors;
      	var sizeData = window._sizes.sizes;
      	var container = $('.variant-frame');
      
      	if (!container.length)
        {
          return;
        }
      
      
      
      	var getColor = function(colorName)
        {
          for (var c = 0; c < colorData.length; c++)
          {
           	var color = colorData[c];
            if (color.t == colorName)
            {
             return color; 
            }
          }
          
          return null;
        };
      
      
      var getSize = function(sizeName)
        {
          for (var s = 0; s < sizeData.length; s++)
          {
           	var size = sizeData[s];
            if (size.t == sizeName)
            {
             return size; 
            }
          }
          
          return null;
        };
      
      
      
      
      	// Set Up form
//       	var colors = [];
      
//       	var colorSelect = $('<select name="option1"></select>');
//       	colorSelect.append('<option value="">-- Select a Color --</option>');
      
//       	variantLoop: for(var vi = 0; vi < v.length; vi++)
//         {
//          	var variant = v[vi];
          
          
//           	// Skip this variant if it exists
//           	for (var t = 0; t < colors.length; t++)
//             {
//              	if (colors[t].color == variant.c)
//                 {
//                  	continue variantLoop; 
//                 }
//             }
          
//           	var colorObject = { color: variant.c, hex: variant.ch };
          
//             colors.push(colorObject);
//         }
      
      
//       var getColor = function(color)
//       {
//        	for(var c = 0; c < colors.length; c++)
//         {
// 			if (colors[c].color == color)
//             {
//               return colors[c];
//             }
//         }
        
//         return null;
//       }
      
      var getVariantsForColor = function(color)
      {
        var variants = [];
        for(var vi = 0; vi < v.length; vi++)
        {
         	var variant = v[vi];
          
          	if (variant.c == color)
            {
              	variants.push(variant);
            }
        }
        
        return variants;
      }
      
      var swatches = container.find('.swatch-row');
      var colorSelect = container.find('[name="color-option"]');
      
      for(var c = 0; c < colorData.length; c++)
      {
        
        var color = colorData[c];
        
        var a = $('<a />');
        a.prop('class', 'swatch');
        a.prop('href', '#');
        a.css('background', '#' + color.h);
        a.attr('data-color', color.t);
        
        a.appendTo(swatches);
        
        var option = $('<option />');
        option.val(color.t);
        option.text(color.t + (color.o ? ' +$' + parseFloat(color.o).toFixed(2) : ''));
        colorSelect.append(option);
      }
      
      
      container.on('setup-variants', '.prices', function(e, color)
      {
        var sizeContainer = $(this);
        var colorVariants = getVariantsForColor(color);
        

        for(var v = 0; v < colorVariants.length; v++)
        {
          var variant = colorVariants[v];
          var sizeDiv = $('<div class="grid__item medium-up--one-eighth variant-input"></div>');
          sizeDiv.append('<span class="price-offset">&nbsp;</span>');
          var sn = $('<div class="size-name"></div>');
          sn.text(abbreivateSize(variant.s));
          var si = $('<input type="number" value="" min="0">');
          si.prop('name', 'variant[' + variant.id + ']');
          
          sizeDiv.append(sn).append(si);
          
          var size = getSize(variant.s);
          if (size && size.o)
          {
            var priceOffset = $('<span class="price-offset"></span>');
            priceOffset.text('+$' + parseFloat(size.o).toFixed(2));
            sizeDiv.append(priceOffset);
          }
          
          sizeDiv.appendTo(sizeContainer);
          
        }
        
      });
      
      container.on('change-color', function(e, color)
      {
        
        // Find Color Object
        var colorO = getColor(color);
        
        if (!colorO)
        {
         return; 
        }
        
        // Handle color selection
        swatches.find('.active').removeClass('active');
        swatches.find('[data-color="' + color + '"]').addClass('active');
        
        
        var latestVariant = $('.selected-variants').find('.variant:last');
        var allEmpty = true;
       

        latestVariant.find('.prices input').each(function()
        {
          	var val = $.trim($(this).val());
        	if (val != '' && val != '0')
            {
             	allEmpty = false;
              	return false;
            }
        });
        

        if (!allEmpty)
        {
        	var newVariant = latestVariant.clone();
          	newVariant.insertAfter(latestVariant);
        }
        else
        {
        	newVariant = latestVariant; 
        }
        
        
        colorSelect = newVariant.find('[name="color-option"]');
        
        if (colorSelect.val() != color)
        {
          colorSelect.val(color);
        }
        
        var sizeContainer = newVariant.find('.text-boxes .prices');
        
        sizeContainer.empty();
        newVariant.find('.selected-color-swatch').css('background', '#' + colorO.h);
        
        
        sizeContainer.trigger('setup-variants', color);
        
        
      });
      
      swatches.on('click', 'a', function(e)
      {
      	e.preventDefault();
        var color = $(this).data('color');
        container.trigger('change-color', color);
      });
      
      
      // Select default to start
      if (window.hasOwnProperty('_defaultColor'))
      {
       	if (window._defaultColor != '')
        {
         	swatches.find('a[data-color="' + window._defaultColor + '"]').click(); 
        }
      }
      
      container.on('change', '[name="color-option"]', function()
      {
      	var color = $(this).val();
        var colorO = getColor(color);
                
        if (!colorO)
        {
        	return; 
        }
        
        
       	var sizeContainer = $(this).closest('.variant').find('.text-boxes .prices');
        
        sizeContainer.empty();
        $(this).closest('.variant').find('.selected-color-swatch').css('background', '#' + colorO.h);
       
        sizeContainer.trigger('setup-variants', color);
      });
      
      
      container.on('click', '.remove', function(e)
      {
      	e.preventDefault();
        $(this).closest('.variant').remove();
      });
      
      $('[data-add-additional-color]').on('click', function(e)
      {
      	e.preventDefault();
        var latestVariant = $('.selected-variants').find('.variant:last');
      	var newVariant = latestVariant.clone();
       	newVariant.insertAfter(latestVariant);
      });
      
      
      $('[data-add-to-cart]').on('click', function(e)
      {
      	e.preventDefault();
        
        // Cycle through each set of selected items
        var atc = [];
        
        container.find('[name*="variant"]').each(function()
        {
          var qty = parseInt($(this).val());
          if (qty <= 0)
          {
            return true; // continue
          }
          
          
          var matches = $(this).prop('name').match(/variant\[([0-9]+)\]/);
          if (matches.length == 2)
          {
          	var variantID = matches[1];
            atc.push({ id: variantID, quantity: qty });
          }
        });
        
        
        if (atc.length)
        {
         for (var a = 0; a < atc.length; a++)
         {
           var item = atc[a];
           $.ajax({
             url: '/cart/add.js',
             async: false,
             type: 'POST',
             data: item,
             success: function()
             {
              // 
             }
           });
         }
        }
        
        window.location = '/cart';
      });

    }
});